import React from 'react';
import ModalContent from 'src/formcontrols/hoc/PopupModal/ModalContent';
import { ComponentType } from 'src/formcontrols/hoc/PopupModal/ModalEnum';
import ModalFooter from 'src/formcontrols/hoc/PopupModal/ModalFooter';
import ModalHeader from 'src/formcontrols/hoc/PopupModal/ModalHeader';
import PopupModal from 'src/formcontrols/hoc/PopupModal/PopupModal';
import * as ColorPalette from 'src/formcontrols/Themes/theme';
import '../EditModal/EditModal.css';
import './InformationModal.css';

interface IProps {
  isModalOpen: boolean;
  isLoading: boolean;
  modalHeader: string;
  onCloseModal?: any;
  children?: React.ReactNode;
}

const editModalStyle = {
  background: ColorPalette.colors.bgDark,
  color: ColorPalette.colors.text,
  fontSize: '14px',
  width: '100%',
};

export const InformationModal: React.FC<IProps> = props => {
  return (
    <PopupModal isModalOpen={props.isModalOpen}>
      <div className="information-modal" style={editModalStyle}>
        <div>
          <ModalHeader
            isComponentLoading={props.isLoading}
            componentHeader={props.isLoading ? '' : props.modalHeader}
            onCloseClicked={props.onCloseModal}
            onPrintClicked={props.onCloseModal}
            componentType={ComponentType.Information}
          />
        </div>
        <div className="information-modal-content">
          <ModalContent isLoading={props.isLoading}>{props.children}</ModalContent>
        </div>
        <div>
          <ModalFooter
            isComponentLoading={props.isLoading}
            onCancelClicked={props.onCloseModal}
            onOperatioConfirmed={props.onCloseModal}
            componentType={ComponentType.Information}
          />
        </div>
      </div>
    </PopupModal>
  );
};
